const GENERAL_URL_API = process.env.NODE_ENV === 'development' ? 'https://nf-api-makemake.reallabs.com.co/admin' : process.env.REACT_APP_API;
export { GENERAL_URL_API };
